<template>
	<div class="flex flex-col gap-[16px]">
		<span class="block">
			<h4 class="skeleton-category-heading"></h4>
		</span>

		<h1 class="title leading-none lg:leading-tight skeleton mb-[16px]"></h1>

		<div class="flex flex-col gap-[12px]">
			<span class="flex items-center gap-[8px]">
				<div class="inline-flex flex-wrap gap-2">
					<span
						width="24"
						height="24"
						class="skeleton !rounded-[32px] min-w-[24px] min-h-[24px]"
					/>

					<span class="flex contributor-profile-avatar skeleton w-[180px]"></span>
				</div>

				<span class="ml-[12px] h-[20px] skeleton w-[180px]"></span>
			</span>
			<span class="flex items-center gap-[16px]">
				<span class="h-[20px] skeleton w-[180px]"></span>
				<span class="ml-[12px] h-[20px] skeleton w-[180px]"></span>
			</span>
		</div>

		<span
			width="740"
			height="420"
			class="skeleton img"
		/>

		<div class="inline-flex flex-wrap gap-[16px] mb-[32px]">
			<span class="skeleton !rounded-[32px] min-w-[32px] min-h-[32px]" />
			<span class="skeleton !rounded-[32px] min-w-[32px] min-h-[32px]" />
			<span class="skeleton !rounded-[32px] min-w-[32px] min-h-[32px]" />
			<span class="skeleton !rounded-[32px] min-w-[32px] min-h-[32px]" />
		</div>

		<span class="flex flex-col gap-[32px]">
			<span class="h-[80px] skeleton w-full"></span>
			<span class="h-[40px] skeleton w-full max-w-[70%]"></span>
		</span>
	</div>
</template>

<style scoped lang="scss">
@keyframes pulse-bg {
	0% {
		background-color: $neutral-200;
	}
	50% {
		background-color: $neutral-300;
		opacity: 0.5;
	}
	100% {
		background-color: $neutral-200;
	}
}

.skeleton-category-heading {
	content: "";
	width: 200px;
	height: 24px;
	border-radius: 4px;
	animation: pulse-bg 1s infinite;
}

.title.skeleton {
	content: "";
	width: full;
	height: 52px;
	border-radius: 4px;
	animation: pulse-bg 1s infinite;
}
.skeleton {
	content: "";
	border-radius: 4px;
	animation: pulse-bg 1s infinite;
}
.img.skeleton {
	content: "";
	height: 420px;
	margin-top: 32px;
}
</style>
